import React, { useEffect, useState } from "react";
import style from "./login.module.css";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import CustomTextfield from "../../../common/input/custom-textfield/custom-textfield";
import LoginAdvertiseSlider from "../../../components/login-advertise-slider/login-advertise-slider";
import { Button, Checkbox } from "antd";
import { sample_schools_adverts } from "../../../constants/common";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/features/userSlice";
import {
  getCookie,
  removeCookie,
  setCookie,
} from "../../../utils/cookie-storage/cookie-storage";
import RoutesConstant from "../../../constants/routes";
import { toast } from "react-toastify";
import { loginUser } from "../../../services/auth";
import { useAbility } from "../../../ability/AbilityContext";
// import { getDeviceToken } from "../../../utils/firebase/firebase";
import { storeAuthCookies } from "../../../utils/cookie-storage/auth-cookie";
import { setLoggedOut } from "../../../config";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setRolePermissions } = useAbility();
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [remeberMe, setRemeberMe] = useState(false);
  const preRemeberMeData = getCookie("remeberme");

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
      password: "",
    },
  });

  useEffect(() => {
    if (preRemeberMeData) {
      const tempRemberData = JSON.parse(preRemeberMeData);
      reset({
        email: tempRemberData?.email,
        password: tempRemberData?.password,
      });
      setRemeberMe(true);
    }
  }, []);

  const onSubmit = async (values) => {
    try {
      setLoggedOut(false);
      setIsLoading(true);
      // const token = await getDeviceToken();
      const payload = {
        user_name: values?.email,
        password: values?.password,
        user_type: "Admin",
      };
      // if (token) payload.device_id = token;
      resetRemeberMe(values);
      const response = await loginUser(payload);
      if (response?.data?.status) {
        const tempData = response?.data?.data;
        const privileges = tempData?.user?.privileges? JSON.parse(tempData?.user?.privileges): [];
        setRolePermissions(privileges);
        storeAuthCookies({
          authToken: tempData?.token?.accessToken,
          refreshToken: tempData?.token?.refreshToken,
          // deviceId: token,
          username: tempData?.user?.user_name,
        });
        const userData = { 
          ...tempData?.user,
          // device_id: token
        };
        dispatch(setUser(userData));
        toast.success("Login Successfully !");
        if (userData?.role === 'ADMIN' && userData?.is_first_login) {
          navigate(RoutesConstant.RESET_PASSWORD_FIRST_LOGIN);
        } else {
          navigate(RoutesConstant.DASHBOARD);
        }
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      toast.error(e?.data?.message || "Error! please try again");
    }
  };

  const resetRemeberMe = (values) => {
    if (remeberMe) {
      setCookie("remeberme", JSON.stringify(values));
    } else {
      removeCookie("remeberme");
    }
  };

  return (
    <div className={style.login_page}>
      <div className={style.left}>
        <div className={style.main_container}></div>
        <div className={style.slider}>
          {sample_schools_adverts.map((school, index) => (
            <LoginAdvertiseSlider
              key={index}
              bg_color={school.bg_color}
              logo_link={school.logo_link}
              school_name={school.school_name}
              heading_color={school.heading_color}
              phone_number={school.phone_number}
              avatar_pic_link={school.avatar_pic_link}
            />
          ))}
        </div>
      </div>
      <div className={style.right}>
        <div className={style.right__container}>
          <h1>Welcome back</h1>
          <p>Please enter your details</p>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={style.login_fields}
          >
            {/* <div > */}
            <Controller
              name="email"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="email"
                  label="User Name"
                  showRequired
                  labelColor="#434343"
                  placeholder="Enter user name"
                  size="large"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />

            <Controller
              name="password"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <CustomTextfield
                  id="password"
                  label="Password"
                  showRequired
                  labelColor="#434343"
                  type={visible ? "text" : "password"}
                  suffix={
                    visible ? (
                      <EyeTwoTone onClick={() => setVisible(!visible)} />
                    ) : (
                      <EyeInvisibleOutlined
                        onClick={() => setVisible(!visible)}
                      />
                    )
                  }
                  placeholder="Enter password"
                  size="large"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
            <div className={style.forgot_password_and_remember_me}>
              <div className={style.remember_me_container__parent}>
                <Checkbox
                  checked={remeberMe}
                  onChange={(e) => setRemeberMe(e?.target?.checked)}
                  style={{ color: "#344054" }}
                >
                  Remember me
                </Checkbox>
              </div>
              <div className={style.forgot_password}>
                <Link to={RoutesConstant.FORGOT_PASSWORD}>Forgot password?</Link>
              </div>
            </div>

            <Button type="primary" htmlType="submit" loading={isLoading}>
              LOGIN
            </Button>
            {/* </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
